export default (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
    },
    error: {
        background: theme.palette.danger,
        color: theme.palette.dangerForeground,
        boxShadow: theme.shadows[1],
        fontWeight: 'bold',
        textAlign: 'left',
        padding: 16,
        marginTop: 4,
        marginBottom: 4,
    },
});
